import developmentNaturalWaterPool from "../abis/development/pools/naturalWaterPool";

const host = "https://bscscan.com/address";

export default [
  {
    title: "Natural Water Pool",
    contractAddress: "0x7eeff1836dc77bb9998b4b123d2c43934e2d28f5",
    minApr: 159,
    abi: developmentNaturalWaterPool.abi,
    url: `${host}/0x7eeff1836dc77bb9998b4b123d2c43934e2d28f5`,
  },
];
